
    import '/mnt/src/components/Toast/index.md?watch=parent';
    export const demoIndex = {
  ids: ["toast-demo-basic"],
  getter: () => import(/* webpackChunkName: "meta__components" */'/mnt/src/components/Toast/index.md?type=demo')
};